import React from 'react';
import { Error } from './Error';

export const NoPermissionError = () => <Error message="Brak uprawnień" />;
